import './App.css';
import Header from './Header';
import Photos from './Photos';

function App() {
  return (
    <div>
     <Header/>
     <Photos/>
    </div>
  );
}

export default App;
